import * as React from 'react';
import { DarkGreySidely2, GreySidely2, LightGreySidely } from '../../styles/global/css/Utils';
import Input from './Input';
import { InputProps } from './model/Model';
import { SearchImageContainer } from './style/Style';
import { Search } from 'lucide-react';

export const SEARCH_INPUT_HEIGHT = '28px';

function InputSearch({ inputStyle, ...props }: InputProps & { noBorderRadius?: boolean }): JSX.Element {
	return (
		(<Input inputStyle={{
			height: SEARCH_INPUT_HEIGHT,
			...inputStyle ?? {
				removePlaceHolderOnFocus: true,
				width: '100%',
				backgroundColor: LightGreySidely,
				borderRadius: props.noBorderRadius ? undefined : '25px',
				color: DarkGreySidely2,
				placeholderColor: GreySidely2,
				hasInputBorder: true,
				border: 'none',
				textOverflow:'ellipsis',
				containerWidth: '100%',
				margin: '0px'
			}
		}} JSXContent={(
			<SearchImageContainer noBorderRadius={props.noBorderRadius}><Search size={14} color={GreySidely2}/></SearchImageContainer>
		)} {...props}/>)
	);
}

export default InputSearch;
